import axios, { AxiosResponse } from "axios";
import { ApiSearchResponse } from "../models/common";
import { ISearchParams, searchParamsInit } from "../models/searchParams";
import { IAddEditVoyage, IVoyage } from "../models/voyage";

export const addVoyage = async (dto: IAddEditVoyage): Promise<AxiosResponse<IVoyage>> => {
    return await axios.post("/docks/voyage", dto);
};

export const changeVoyage = async (dto: IAddEditVoyage): Promise<AxiosResponse<IVoyage>> => {
    return await axios.patch("/docks/voyage", dto);
};

export const deleteVoyage = async (id: string): Promise<AxiosResponse<string>> => {
    return await axios.delete(`/docks/voyage/${id}`);
};

export const getVoyage = async (id: string): Promise<AxiosResponse<IVoyage>> => {
    return await axios.get(`/docks/voyage/${id}`);
};

export const searchVoyages = async (
    searchParams: ISearchParams = searchParamsInit,
): ApiSearchResponse<IVoyage> => {
    return await axios.post("/docks/voyage/search", searchParams);
};

export const importVoyageAndStops = async (csv: string): Promise<AxiosResponse<IVoyage[]>> => {
    return await axios.post("/docks/voyage/import", { csv });
};

export const changeVoyageAvailable = async (voyageId: number): Promise<AxiosResponse<boolean>> => {
    return await axios.get(`/docks/voyage/changeVoyageAvailable/${voyageId}`);
};
